import { createSelector } from 'reselect';
import { createFeatureSelector } from 'common/create-feature-selector';

export const rootSelector = createFeatureSelector('modelErrorCode');
export const getModelErrorCode = createSelector(rootSelector, (e) => e);
